// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__1+0RC","main":"Tabs_main__e3wY1","tab":"Tabs_tab__kQS+9","devider":"Tabs_devider__XWfkM","devider_active":"Tabs_devider_active__5JUu9"};